import depotIcon from '@chama/statics/assets/img/map-markers/ui-map-marker-depot.png';

export default function styleMap() {
  // this == React Map component
  const {
    google,
    map,
    props: { editMapMode, editPolygonMode, dragPolygonMode },
  } = this;

  map.data.setStyle({
    editable: editPolygonMode,
    draggable: dragPolygonMode,
    fillColor: editMapMode ? '#31c9f9' : '#99a3c8',
    fillOpacity: 0.3,
    strokeColor: editMapMode ? '#31c9f9' : 'transparent',
    strokeWeight: editPolygonMode ? 5 : 2,
    icon: {
      url: depotIcon,
      scaledSize: new google.maps.Size(66, 72),
      anchor: new google.maps.Point(33, 68),
    },
  });
}



// WEBPACK FOOTER //
// ../ui-components/components/CoverageAreaMap/components/Map/methods/styleMap.js